import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-lines-b',
  templateUrl: './consignment-lines-b.component.html',
  styleUrls: ['./consignment-lines-b.component.css']
})
export class ConsignmentLinesBComponent implements OnInit {
    consignmentLinesBKeyno;

    public stockBatchButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockbatchget', gotoParms: () => this.menu!.stockbatch_keyno ?? '' }];

    public menu?: Menu;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentLinesBKeyno = this.stateService.getStateParams()['consignmentlinesb_keyno'];
    }

    private async loadMenu() {
        if (!!this.consignmentLinesBKeyno) {
            this.menu = (await this.datatask.Post(756, { consignmentlinesb_keyno: this.consignmentLinesBKeyno }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(757, this.menu);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    consignmentlinesb_keyno: string;
    stockbatch_keyno: string;
    quantity: string;
    consignmentline_keyno: string;
    show_delete: string;
}
